import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PublicFooter() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#1A1411] text-[#E6D5B8] pt-12 md:pt-20 pb-8 md:pb-10 border-t border-[#302621]">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-16">
          <div>
            <img src="/logo putih.png" alt="Satala Logo" className="h-8 md:h-10 w-auto mb-5 md:mb-6 opacity-90" />
            <p className="text-xs md:text-sm opacity-70 leading-relaxed mb-5 md:mb-6">
              Mitra maklon terpercaya untuk mewujudkan brand kosmetik dan skincare berkualitas tinggi.
            </p>
            <div className="flex gap-4 opacity-80">
              <a href="https://www.facebook.com/profile.php?id=61571481996078" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] hover:text-[#1A1411] transition-colors cursor-pointer text-white">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/sataladermatechessential?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] hover:text-[#1A1411] transition-colors cursor-pointer text-white">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-white mb-6 uppercase text-sm tracking-widest">Perusahaan</h4>
            <ul className="space-y-3 text-sm opacity-70">
              <li><div onClick={() => navigate('/tentang-kami')} className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Tentang Kami</div></li>
              <li><div className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Visi Misi</div></li>
              <li><div className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Nilai Perusahaan</div></li>
              <li><div className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Fasilitas</div></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-6 uppercase text-sm tracking-widest">Layanan</h4>
            <ul className="space-y-3 text-sm opacity-70">
              <li><div onClick={() => navigate('/layanan/maklon-kosmetik')} className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Maklon Kosmetik</div></li>
              <li><div onClick={() => navigate('/layanan/formulasi')} className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Formulasi</div></li>
              <li><div onClick={() => navigate('/layanan/desain-kemasan')} className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Desain & Kemasan</div></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-6 uppercase text-sm tracking-widest">Informasi</h4>
            <ul className="space-y-3 text-sm opacity-70">
              <li><div className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">FAQ</div></li>
              <li><div onClick={() => navigate('/partner')} className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Partner</div></li>
              <li><div onClick={() => navigate('/kontak')} className="cursor-pointer hover:text-[#D4AF37] hover:opacity-100 transition-colors">Kontak</div></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs opacity-50">
          <p>© 2026 Satala Dermatech. All Rights Reserved.</p>
          <div className="flex gap-6">
            <span className="hover:text-[#D4AF37] hover:opacity-100 transition-colors cursor-pointer">Kebijakan Privasi</span>
            <span className="hover:text-[#D4AF37] hover:opacity-100 transition-colors cursor-pointer">Syarat & Ketentuan</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
